import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsStandUpPaddlingNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6.68 25.241l-.588 3.875a2.355 2.355 0 002.328 2.71h1.215a2.357 2.357 0 002.338-2.644l-.473-3.874A2.427 2.427 0 009.825 23.3V2.825h.67v-1.65H7.481v1.65h.694v20.527a2.414 2.414 0 00-1.495 1.889zm1.631.248a.78.78 0 011.546.021l.478 3.874a.7.7 0 01-.7.791H8.42a.704.704 0 01-.7-.811l.591-3.875zM19.458 14.228a2.775 2.775 0 00-2.187 2.758c0 1.925.288 3.839.854 5.678l.973 3.161h1.8l.973-3.16c.573-1.867.86-3.809.854-5.76a2.73 2.73 0 00-3.27-2.677h.003zm.84 7.951l-.3.968-.3-.969a17.633 17.633 0 01-.78-5.193 1.14 1.14 0 01.852-1.138c.076-.014.153-.022.23-.022a1.067 1.067 0 01.99.657c.068.158.098.33.09.503 0 1.76-.262 3.511-.78 5.194h-.002z"
        fill=""
      />
      <path
        d="M20 .174a4.017 4.017 0 00-3.536 2.061 19.336 19.336 0 00-2.509 9.515c0 5.07.69 10.116 2.053 15l1.01 3.615a2.036 2.036 0 001.954 1.483h2.056a2.036 2.036 0 001.955-1.484l1.008-3.614a55.78 55.78 0 002.054-15 19.336 19.336 0 00-2.509-9.515A4.017 4.017 0 0020 .174zM22.4 26.3l-1.008 3.614a.38.38 0 01-.366.278h-2.054a.38.38 0 01-.366-.277L17.6 26.3a54.157 54.157 0 01-1.995-14.55c.002-3.05.792-6.046 2.294-8.7a2.415 2.415 0 014.2 0 17.685 17.685 0 012.294 8.7c0 4.918-.67 9.813-1.993 14.55z"
        fill=""
      />
    </svg>
  )
);
SvgSportsStandUpPaddlingNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsStandUpPaddlingNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsStandUpPaddlingNormalMedium;
